























import Vue from 'vue';
import SIcon from '../SIcon/SIcon.vue';

/**
 * This component is not used anywhere other than the 'SAction' component and is an abstraction to
 * make the tooltip on/off logic simpler
 */
export default Vue.extend({
  name: 'SActionButton',
  components: {
    SIcon,
  },
  props: {
    /**
     * Used to switch which icons, labels & tooltips are displayed
     * NOTE: Enabling this shows 'iconAlt' rather than 'icon'
     */
    toggle: {
      type: Boolean,
      required: false,
    },
    /**
     * Turns the component into more of a button
     * NOTE: Requires 'toggle' prop to be 'true'
     */
    label: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * Text to display when toggle is false
     */
    labelAlt: {
      type: String,
      required: false,
    },
    /**
     * Background colour of the button
     */
    buttonColor: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * Color to set the icon to
     */
    iconColor: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * The icon to use for the component when toggle is false
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * Icon to use for the component when toggle is true
     */
    iconAlt: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * The size of the icon
     */
    iconSize: {
      type: String,
      required: true,
    },
    /**
     * The $listeners object from SAction
     */
    listeners: {
      type: Object,
      required: true,
    },
  },
});
